const ThankYou = () => {
    return <p><center>Thank you for signing up for Asset Vue. You will receive an email with information to sign in.</center></p>
}

export default ThankYou;